<template>
    <main class="charts">
        <div class="static-charts">
            <app-chart
                :loading="loading"
                class="half-width"
                data-name="mostViewedSites"
                data-type="doughnut"
                :data-heading="$t('message.statistics.message.mostViewedSites')"
            />

            <app-chart
                :loading="loading"
                class="half-width"
                data-name="mostViewedIps"
                data-type="doughnut"
                :data-heading="$t('message.statistics.message.mostViewedIps')"
            />

            <app-chart
                :loading="loading"
                class="half-width"
                data-name="mostUsedProtocols"
                data-type="doughnut"
                :data-heading="
                    $t('message.statistics.message.mostUsedProtocols')
                "
            />

            <app-chart
                :loading="loading"
                :totalLabels="['Download', 'Upload', this.$t('message.statistics.message.totalClients')]"
                class="full-width"
                data-name="usedBandwidth"
                data-type="line"
                :data-heading="'Consumo de Dados'"
                :data-tooltip="'Consumo de dados utilizados pelos clientes. Todos os dados exibidos em Download e Upload estão Kb/s.'"
            />
        </div>
    </main>
</template>

<script>
import AppChart from "@components/chart/Chart";
import AppStatisticCard from "@components/StatisticCard";
import AppModal from "@views/statistics/components/answers-statistics-modal/AnswerStatisticModal";
import EventBus from "@packages/event-bus";
import moment from "moment";

export default {
    components: {
        AppChart,
        AppStatisticCard,
        AppModal,
    },

    data() {
        return {
            loading: false,
        };
    },

    computed: {
        filters() {
            return this.$store.state.statistics.filters;
        },
    },

    methods: {
        async loadStatistics() {
            this.loading = true;

            const date = this.filters.date;

            const response = await this.$api.beholder.getMonitorStatistics({
                ...date,
                networks: this.filters.networks
            });

            this.setChartValue(response);

            this.loading = false;
        },

        setChartValue(data) {
            this.updateChartStorage(
                data.mostViewedSites,
                "STATISTICS_SET_MOST_VIEWED_SITES"
            );

            this.updateChartStorage(
                data.mostViewedIps,
                "STATISTICS_SET_MOST_VIEWED_IPS"
            );

            this.updateChartStorage(
                data.mostUsedProtocols,
                "STATISTICS_SET_MOST_USED_PROTOCOLS"
            );

            this.updateUsedBandwidth(data.usedBandwidth);
        },

        updateChartStorage(data, key) {
            const chart = {
                label: key,
                data: [],
            };

            const mappedChart = {
                labels: [],
                datasets: [chart],
                count: 0,
            };

            Object.keys(data).forEach((key) => {
                const value = data[key];

                chart.data.push(value);

                mappedChart.labels.push(key);

                mappedChart.count += value;
            });

            this.$store.commit(key, mappedChart);
        },

        updateUsedBandwidth(data) {
            const mappedChart = {
                labels: [],
                datasets: [],
                count: [0, 0, 0]
            };

            const downloadChart = {
                label: 'Download',
                data: []
            };

            const uploadChart = {
                label: 'Upload',
                data: []
            };

            const totalClientsChart = {
                label: this.$t('message.statistics.message.totalClients'),
                data: []
            };

            const orderedDates = this.orderDates(Object.keys(data));

            orderedDates.forEach(key => {
                const download = data[key].download;
                const upload = data[key].upload;
                const clients = data[key].totalClients;

                downloadChart.data.push(download);
                uploadChart.data.push(upload);
                totalClientsChart.data.push(clients);


                mappedChart.count[0] += download;
                mappedChart.count[1] += upload;
                mappedChart.count[2] += clients;

                mappedChart.labels.push(
                    this.formatDate(key)
                );
            });

            mappedChart.datasets.push(downloadChart);
            mappedChart.datasets.push(uploadChart);
            mappedChart.datasets.push(totalClientsChart);

            this.$store.commit("STATISTICS_SET_USED_BANDWIDTH", mappedChart);
        },

        chartKey(chart) {
            return `${chart.interactionBody.id}-${this.$date.timestamp()}`;
        },

        orderDates(dates) {
            return dates.sort((dateA, dateB) => {
                return moment(dateA, "YYYY-MM-DD").diff(moment(dateB, "YYYY-MM-DD"));
            });
        },

        formatDate (date) {
            return moment(date, "YYYY-MM-DD").format("DD/MMM");
        }
    },

    mounted() {
        this.loadStatistics();

        EventBus.$on("STATISTICS_FILTER_RELOAD", this.loadStatistics);
    },

    beforeDestroy() {
        EventBus.$off("STATISTICS_FILTER_RELOAD", this.loadStatistics);
        this.$store.commit("STATISTICS_RESET_FILTERS");
    },
};
</script>

<style lang="scss" scoped>
.charts {
    & > * {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        & > * {
            margin-bottom: 30px;
        }
    }

    .full-width {
        width: calc(100%) !important;
    }

    .static-charts {
        .cards {
            @extend .half-width;

            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            & > * {
                width: calc(50% - 10px);
                height: calc(50% - 10px);

                &:nth-last-child(-n + 3) {
                    margin-bottom: 20px;
                }
            }
        }
    }

    .half-width {
        width: calc(50% - 15px) !important;
    }

    .third-width {
        width: calc(33.33% - 22px) !important;
    }
}

@media only screen and (max-width: 1400px) {
    .dynamic-charts > .half-width {
        width: 100% !important;
    }
}
</style>
